<header>
  <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light" style="border-bottom: 1px solid #cecece; box-shadow: 0 0 1em gray;">
    <a class="navbar-brand" href="#">
      <img src="./assets/logo_{{this.logo}}.jpg" loading="lazy" style="width: 200px; margin-left: 12px;">
    </a>

    <ul class="collapse navbar-collapse"></ul>

    <span class="text-danger ml-2" style="margin-top: 25px; font-size: 0.7rem;">v1.0.1</span>
  </nav>
</header>

<app-custom-loader></app-custom-loader>

<app-custom-alert style="position: relative; top: 85px" [dataSource]="this.dsAlert"></app-custom-alert>

<div class="container-fluid" style="margin-top: 6rem!important;">

  <router-outlet></router-outlet>

</div>
